import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface EnvironmentModuleConfig {
  appDomain: string; // 'culturequestion.com',
  appKey: string, // 'culturequestion',
  appUrl: string, // 'https://culturequestion.com',
  apiUrl: string,
  apiProxyDomain?: string,
  production: boolean,
  name: string, // name of the environment, for example 'staging'
  imageHostIdentifier: string, // Cloudinary cloud name, e.g. 'cebt' / 'cebt-staging' / 'cebt-dev'

}

export const APP_ENV = new InjectionToken<EnvironmentModuleConfig>('APP_ENV');

@NgModule({
  imports: [CommonModule],
})
export class EnvironmentModule {
  static withConfig(config: EnvironmentModuleConfig): ModuleWithProviders<EnvironmentModule> {
    const resolvedConfig: EnvironmentModuleConfig = config;

    const providers = [
      { provide: APP_ENV, useValue: resolvedConfig },
      { provide: 'appDomain', useValue: resolvedConfig.appDomain },
      { provide: 'appKey', useValue: resolvedConfig.appKey },
      { provide: 'appUrl', useValue: resolvedConfig.appUrl },
      { provide: 'apiUrl', useValue: resolvedConfig.apiUrl },
      { provide: 'production', useValue: resolvedConfig.production },
      { provide: 'name', useValue: resolvedConfig.name },
      { provide: 'imageHostIdentifier', useValue: resolvedConfig.imageHostIdentifier },
    ];
    if (resolvedConfig.apiProxyDomain) {
      providers.push({ provide: 'apiProxyDomain', useValue: resolvedConfig.apiProxyDomain });
    }
    return {
      ngModule: EnvironmentModule,
      providers,
    };
  }
}
